<template>
    <div class="vld-parent">
        <loading :active.sync="bool_fullLoading" :is-full-page="bool_fullScreen"></loading>
        <div v-if="bool_isAMV">
            <transition name="modal-fade">
                <div class="modal-backdrop" margin="auto">
                    <div style="width:55%">
                        <CCard>
                            <CCardBody class="modal-body">
                                <CRow>
                                    <CCol col="8">
                                        <h4 id="traffic" class="card-title mb-0">{{this.getLanguage["SMSSP"][obj_sms.I > 0? "ES": "AS"]}}</h4>
                                    </CCol>
                                    <CCol col="4">

                                        <CButton id="btn-close1" class="float-right"
                                                 @click="closeAdd()">

                                            <CIcon name=cilX></CIcon>

                                        </CButton>
                                    </CCol>
                                </CRow>
                                <div class='subHeaderHR'></div>
                                <CRow>
                                    <CCol col="6">
                                        <label class="col-form-label-sm"> {{this.getLanguage["SMSSP"]["PN"]}}<span class="required" /> :</label>
                                        <treeselect :multiple="false"
                                                    :options="dd_providers"
                                                    :flat="false"
                                                    :defaultExpandLevel="Infinity"
                                                    v-model="obj_sms.PN"
                                                    ref="PN" />
                                        <span class="ErrMsg">{{ ValidationErrMsg('PN','PN') }}</span>
                                    </CCol>
                                    <CCol col="6">
                                        <label class="col-form-label-sm"> {{this.getLanguage["SMSSP"]["AGI"]}}<span class="required" /> :</label>
                                        <customtreeselect :multiple="false"
                                                    :options="dd_agentgroup"
                                                    :defaultExpandLevel="Infinity"
                                                    :clearable="false"
                                                    :placeholder="this.getLanguage['SMSSP']['AGI']"
                                                    v-model="obj_sms.AGIT"
                                                    :disabled="obj_sms.I > 0 || isSuperAdmin"
                                                    ref="AGIT" />
                                        <span class="ErrMsg">{{ ValidationErrMsg('AGIT','AGI') }}</span>
                                    </CCol>
                                </CRow>
                                <CRow>
                                    <CCol col="6">
                                        <label class="col-form-label-sm"> {{this.getLanguage["SMSSP"]["ASID"]}}<span class="required" /> :</label>
                                        <CInput size="sm" vertical :placeholder="this.getLanguage['SMSSP']['ASID']" :value="obj_sms.ASID" @change="v => obj_sms.ASID = v" ref="ASID"></CInput>
                                        <span class="ErrMsg">{{ ValidationErrMsg('ASID','ASID') }}</span>
                                    </CCol>
                                    <CCol col="6">
                                        <label class="col-form-label-sm">{{this.getLanguage["SMSSP"]["AAT"]}}<span class="required" /> :</label>
                                        <CInput size="sm" vertical :placeholder="this.getLanguage['SMSSP']['AAT']" :value="obj_sms.AAT" @change="v => obj_sms.AAT = v" ref="AAT"></CInput>
                                        <span class="ErrMsg">{{ ValidationErrMsg('AAT','AAT') }}</span>
                                    </CCol>
                                </CRow>
                                <CRow>
                                    <CCol col="6">
                                        <label class="col-form-label-sm">{{this.getLanguage["SMSSP"]["FN"]}}<span class="required" /> :</label>
                                        <CInput size="sm" vertical :placeholder="this.getLanguage['SMSSP']['FN']" :value="obj_sms.FN" @change="v => obj_sms.FN = v" ref="FN"></CInput>
                                        <span class="ErrMsg">{{ ValidationErrMsg('FN','FN') }}</span>
                                    </CCol>
                                    <CCol col="6">
                                        <div style="margin-bottom:20px">
                                            <label class="col-form-label-sm">{{getLanguage["GL"]["S"]}} :</label><br>
                                            <label class="switch">
                                                <input type="checkbox" :checked="obj_sms.RS==1?false:true" @change="v => obj_sms.RS = v.target.checked">
                                                <span class="slider round"></span>
                                            </label>
                                        </div>
                                    </CCol>
                                </CRow>
                                <div style="text-align:center;margin-top:20px">
                                    <CButton color="outline-info" size="sm" @click="saveSMS()">
                                        <span class='plusIcon cil-plus'></span>
                                        {{this.getLanguage["BTN"]["SV"]}}
                                    </CButton>
                                </div>
                                <label class="mandatory_Field">{{this.getLanguage['MANDATORY']['FIELDS']}}</label>


                            </CCardBody>
                        </CCard>
                    </div>
                </div>
            </transition>
        </div>

        <div class="container-fluid">
            <CRow>
                <CCol>
                    <div class='pageHeader position-relative'>
                        <h2 id="titleHeight">{{getLanguage['SMB']["SMSSP"]}}</h2>
                        <CButton size="sm" color="outline-info" v-if="checkModuleAccess2(constAccessType.add)" @click="addSMS()"> <span class='plusIcon cil-plus'></span> {{getLanguage["BTN"]["AN"]}}</CButton>

                        <div class="custom_tooltip position-absolute" style="right: 0; border: 0.5rem;" @click="bool_showSearchBar ? bool_showSearchBar = false:bool_showSearchBar = true">
                            <img src="../../../assets/icons/file-search.svg" width="23" />
                            <span class="tooltiptext tooltip-left" v-if="bool_showSearchBar">{{getLanguage["BTN"]["CSB"]}}</span>
                            <span class="tooltiptext tooltip-left" v-else>{{getLanguage["BTN"]["SSB"]}}</span>
                        </div>
                    </div>
                    <div class="searchForm" v-show="bool_showSearchBar">
                        <div class='searchBox'>
                            <div class='searchCol'>
                                <span class='searchLabel80'>{{this.getLanguage["SMSSP"]["AGI"]}} :</span>
                                <customtreeselect :multiple="false"
                                            :options="dd_agentgroup"
                                            :defaultExpandLevel="Infinity"
                                            :placeholder="this.utilGetDDLanguage('SMSSP.AGI')"
                                            v-model="arr_search['ATAGI']" />
                            </div>
                            <div class='searchCol'>
                                <label class=" searchLabel">{{this.getLanguage["GL"]["S"]}} :</label>
                                <treeselect :multiple="false"
                                            :options="dd_status"
                                            :clearable="true"
                                            :placeholder="this.utilGetDDLanguage('GL.S')"
                                            :max-height="200"
                                            v-model="arr_search['ST']" />
                            </div>
                            <div class='searchCol'>
                                <span class='searchLabel'>{{this.getLanguage['GL']['SD']}} :</span>
                                <date-range-picker :show-dropdowns="true"
                                                   opens="center"
                                                   :auto-apply="true"
                                                   v-model="arr_search['DR']"
                                                   @update="defaultDateRangePickerUpdateEvent"
                                                   :ranges="getDefaultDateRange()">
                                    <div slot="input" slot-scope="picker">
                                        <div v-if="arr_search['DR'].startDate != ''">
                                            <CInput size="sm"
                                                    :value="arr_search['DR'].startDate | moment('DD MMM YYYY HH:mm:ss')"
                                                    @change="DateTimeChange('SD',$event)" />
                                        </div>
                                        <div v-else>
                                            <CInput size="sm"
                                                    @change="DateTimeChange('SD',$event)" />
                                        </div>
                                    </div>
                                </date-range-picker>
                                <CButton class="dr-clear" size="sm" @click="clearDateRangeFilter()">
                                    <CIcon name="cilX" size="sm"></CIcon>
                                </CButton>
                            </div>
                            <div class='searchCol'>
                                <span class='searchLabel'>{{this.getLanguage['GL']['ED']}} :</span>
                                <date-range-picker :show-dropdowns="true"
                                                   opens="left"
                                                   :auto-apply="true"
                                                   v-model="arr_search['DR']"
                                                   @update="defaultDateRangePickerUpdateEvent"
                                                   :ranges="getDefaultDateRange()">
                                    <div slot="input" slot-scope="picker">
                                        <div v-if="arr_search['DR'].endDate != ''">
                                            <CInput size="sm"
                                                    :value="arr_search['DR'].endDate | moment('DD MMM YYYY HH:mm:ss')"
                                                    @change="DateTimeChange('ED',$event)" />
                                        </div>
                                        <div v-else>
                                            <CInput size="sm"
                                                    @change="DateTimeChange('ED',$event)" />
                                        </div>
                                    </div>
                                </date-range-picker>
                                <CButton class="dr-clear" size="sm" @click="clearDateRangeFilter()">
                                    <CIcon name="cilX" size="sm"></CIcon>
                                </CButton>
                            </div>
                        </div>
                        <div class='searchBtnCol'>
                            <CButton v-shortkey="['enter']" @shortkey="newSearch()" ref="search" class='searchBtn' size="sm" block color="success" @click=" newSearch()"><span class='searchIcon cil-search'></span><span>{{getLanguage["BTN"]["SR"]}}</span></CButton>
                        </div>
                    </div>
                </CCol>
            </CRow>


            <div class='table-wrapper'>
                <header class="table-header">
                    <strong>{{getLanguage['SMB']["SMSSP"]}}</strong>
                    <div class="pageBtn">
                        <button @click="ctrPage(+int_Page - 1)">
                            <span class="arrowLeft"></span>
                        </button>
                        <input class="page-control"
                               v-model="int_Page"
                               type="number"
                               v-shortkey.avoid
                               @keyup="ctrPage(+int_Page,0)" />
                        <span class="tableItemCount">/ {{int_TP}}</span>
                        <button @click="ctrPage(+int_Page + 1)">
                            <span class="arrowRight"></span>
                        </button>
                    </div>
                </header>

                <div class="custom-table-wrapper" id="tHead">
                    <table class='custom-table afb-blue'>
                        <thead>
                            <tr>
                                <th>{{getLanguage["GL"]["NO"]}}</th>
                                <th v-if="checkModuleAccess2(constAccessType.edit)|| checkModuleAccess2(constAccessType.delete)">{{getLanguage["GL"]["ACT"]}}</th>
                                <th>{{getLanguage["SMSSP"]["GN"]}} <i @click="setSortTable('GN')" :class="setSortLogo('GN')" class="sortlogo"></i></th>
                                <th v-if="checkModuleAccess2(constAccessType.edit)">{{getLanguage["GL"]["S"]}} <i @click="setSortTable('RS')" :class="setSortLogo('RS')" class="sortlogo"></i></th>
                                <th>{{getLanguage["SMSSP"]["PN"]}}</th>
                                <th>{{getLanguage["SMSSP"]["ASID"]}} <i @click="setSortTable('ASID')" :class="setSortLogo('ASID')" class="sortlogo"></i></th>
                                <th>{{getLanguage["SMSSP"]["AAT"]}} <i @click="setSortTable('AAT')" :class="setSortLogo('AAT')" class="sortlogo"></i></th>
                                <th>{{getLanguage["SMSSP"]["FN"]}} <i @click="setSortTable('FN')" :class="setSortLogo('FN')" class="sortlogo"></i></th>
                                <th> {{getLanguage["GL"]["CT"]}} <i @click="setSortTable('CTS')" :class="setSortLogo('CTS')" class="sortlogo"></i></th>
                                <th> {{getLanguage["GL"]["CB"]}} </th>
                                <th> {{getLanguage["GL"]["UTS"]}} <i @click="setSortTable('UTS')" :class="setSortLogo('UTS')" class="sortlogo"></i></th>
                                <th> {{getLanguage["GL"]["UB"]}} </th>
                            </tr>
                        </thead>
                    </table>
                </div>
                <div class="custom-table-wrapper" id="tBody">
                    <table class='custom-table afb-blue'>
                        <thead>
                            <tr>
                                <th>{{getLanguage["GL"]["NO"]}}</th>
                                <th v-if="checkModuleAccess2(constAccessType.edit)|| checkModuleAccess2(constAccessType.delete)">{{getLanguage["GL"]["ACT"]}}</th>
                                <th>{{getLanguage["SMSSP"]["GN"]}} <i @click="setSortTable('GN')" :class="setSortLogo('GN')" class="sortlogo"></i></th>
                                <th v-if="checkModuleAccess2(constAccessType.edit)">{{getLanguage["GL"]["S"]}} <i @click="setSortTable('RS')" :class="setSortLogo('RS')" class="sortlogo"></i></th>
                                <th>{{getLanguage["SMSSP"]["PN"]}}</th>
                                <th>{{getLanguage["SMSSP"]["ASID"]}} <i @click="setSortTable('ASID')" :class="setSortLogo('ASID')" class="sortlogo"></i></th>
                                <th>{{getLanguage["SMSSP"]["AAT"]}} <i @click="setSortTable('AAT')" :class="setSortLogo('AAT')" class="sortlogo"></i></th>
                                <th>{{getLanguage["SMSSP"]["FN"]}} <i @click="setSortTable('FN')" :class="setSortLogo('FN')" class="sortlogo"></i></th>
                                <th> {{getLanguage["GL"]["CT"]}} <i @click="setSortTable('CTS')" :class="setSortLogo('CTS')" class="sortlogo"></i></th>
                                <th> {{getLanguage["GL"]["CB"]}} </th>
                                <th> {{getLanguage["GL"]["UTS"]}} <i @click="setSortTable('UTS')" :class="setSortLogo('UTS')" class="sortlogo"></i></th>
                                <th> {{getLanguage["GL"]["UB"]}} </th>
                            </tr>
                        </thead>
                        <tbody>
                        <td colspan="100%" v-if=" arr_sms.length == 0">{{this.getLanguage['GL']['NR']}}</td>
                        <tr v-for="(data,index) in arr_sms" v-bind:key="index">
                            <td>{{ CountItem(index+1)}}</td>
                            <td v-if="checkModuleAccess2(constAccessType.edit)|| checkModuleAccess2(constAccessType.delete)">
                                <span id="actionBtnCol">
                                    <div class="custom_tooltip" v-if="checkModuleAccess2(constAccessType.delete)">
                                        <i class="cil-trash" @click='removeSMS(data)'></i> <!--here Remove -->
                                        <span class="tooltiptext">{{getLanguage["BTN"]["DLT"]}}</span>
                                    </div>
                                    <div class="custom_tooltip" v-if="checkModuleAccess2(constAccessType.edit)">
                                        <i class="cil-color-border" @click='editSMS(data.I)'></i> <!--here Edit -->
                                        <span class="tooltiptext">{{getLanguage["BTN"]["ED"]}}</span>
                                    </div>
                                </span>
                            </td>
                            <td>{{ data.GN }} ({{ data.PC }})</td>
                            <td v-if="checkModuleAccess2(constAccessType.edit)">
                                <CCol col="4">
                                    <label class="switch">
                                        <input type="checkbox" true-value="2" false-value="1" v-model="data.RS" @click="updateStatus(data)">
                                        <span class="slider round"></span>
                                    </label>
                                </CCol>
                            </td>
                            <td>{{ data.PN }}</td>
                            <td>{{ stringMasking(data.ASID) }}</td>
                            <td>{{ stringMasking(data.AAT)}}</td>
                            <td>{{ data.FN }}</td>
                            <td>{{ formatDateTime(data.CTS, "YYYY-MM-DD HH:mm:ss", "DD MMM YYYY HH:mm:ss") }}</td>
                            <td>{{ data.CB }}</td>
                            <td>{{ formatDateTime(data.UTS, "YYYY-MM-DD HH:mm:ss", "DD MMM YYYY HH:mm:ss") }}</td>
                            <td>{{ data.UB }}</td>
                        </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import Treeselect from '@riophae/vue-treeselect'
    import { customtreeselect } from '@/views/CustomControl/index.js'
    import DateRangePicker from 'vue2-daterange-picker'
    //you need to import the CSS manually (in case you want to override it)
    import Loading from 'vue-loading-overlay';
    import { mapGetters, mapActions } from 'vuex';
    import { required, minLength, between, url } from 'vuelidate/lib/validators'
    import { constAccessType, constCountryCode, loadingFullScreen } from '@/modules/Constant.js';
    import genericHelper from "@/modules/GenericHelper.js";
    import Vue from 'vue'
    import $ from 'jquery'
    import moment from "moment";
    //Vue.use(require('vue-shortkey'))

    export default {
        mixins: [genericHelper],
        components: {
            Treeselect,
            customtreeselect,
            Loading,
            DateRangePicker
        },
        data() {
            return {
                isSuperAdmin: false,
                bool_isAMV: false, // Add Modal Visible
                int_lblPage: 1,
                bool_fullLoading: false,
                bool_fullScreen: loadingFullScreen, //Full Screen
                bool_showSearchBar: true,
                timeout: null,
                //the parameter of getList()
                int_Page: 1,//current Pagr
                int_IC: 1, // Item Count
                int_RC: 100, //Row Count
                str_tableSortBy: "CTS", //(sort the table col name)
                bool_isSort: true, // Table Ascending Descending
                arr_search: {
                    "ATAGI": null,
                    "ST": 3,
                    "DR": {
                        startDate: "",
                        endDate: ""
                    }
                },
                //ctrl Page valuev (A return Data )
                int_TI: 0,//Total Items
                int_TP: 1, //Total Page
                isEdit: true,
                bool_CV: false, // Check Validation
                arr_sms: [],
                obj_sms: {
                    I: 0,
                    RS: 2,
                    CTS: "0001-01-01T00:00:00",
                    CBI: 0,
                    CB: null,
                    UTS: "0001-01-01T00:00:00",
                    UBI: 0,
                    UB: null,
                    PN: null,
                    AGI: 0,
                    AGIT: null,
                    ASID: "",
                    AAT: "",
                    FN: ""
                },
                constAccessType: constAccessType,
                dd_status: [],
                dd_providers: [],
                dd_agentgroup: []
            }
        },
        validations: {
            obj_sms: {
                PN: { required },
                ASID: { required },
                AAT: { required },
                FN: { required },
                AGIT: { required }
            }
        },
        computed: {
            ...mapGetters('Language', ['getLanguage']),
            ...mapGetters('UserInfo', ['checkModuleAccess']),
            ...mapGetters('UserInfo', ['getUserInfo']),
        },
        methods: {
            stringMasking(str) {
                var str1 = str.substring(0, str.length - 4);
                var str2 = str.substring(str.length - 4);
                var newStr = str1.replace(/./g, '*') + str2;
                return newStr;
            },
            DateTimeChange(type, event) {
                if (type == "SD") {
                    var momentObj = moment(event, 'DD MMM YYYY HH:mm:ss');
                    var dateObj = new Date(momentObj);
                    if (dateObj != "Invalid Date" && event != "") {
                        this.arr_search.DR.startDate = dateObj;
                    }
                    else if (event != "") {
                        this.showErrorMessage(null, String.format(this.utilGetErrorLanguage('1011'), this.getLanguage["GL"]["SD"]), 1000);
                    } else {
                        this.arr_search.DR.startDate = "";
                    }
                }
                if (type == "ED") {
                    var momentObj = moment(event, 'DD MMM YYYY HH:mm:ss');
                    var dateObj = new Date(momentObj);
                    if (dateObj != "Invalid Date" && event != "") {
                        this.arr_search.DR.endDate = dateObj;
                    }
                    else if (event != "") {
                        this.showErrorMessage(null, String.format(this.utilGetErrorLanguage('1011'), this.getLanguage["GL"]["ED"]), 1000);
                    } else {
                        this.arr_search.DR.endDate = "";
                    }
                }
                if (type == "ASD") {
                    var momentObj = moment(event, 'DD MMM YYYY HH:mm:ss');
                    var dateObj = new Date(momentObj);
                    if (dateObj != "Invalid Date" && event != "") {
                        this.obj_Promotion.DR.startDate = dateObj;
                    }
                    else if (event != "") {
                        this.showErrorMessage(null, String.format(this.utilGetErrorLanguage('1011'), this.getLanguage["GL"]["SD"]), 1000);
                    } else {
                        this.obj_Promotion.DR.startDate = "";
                    }
                }
                if (type == "AED") {
                    var momentObj = moment(event, 'DD MMM YYYY HH:mm:ss');
                    var dateObj = new Date(momentObj);
                    if (dateObj != "Invalid Date" && event != "") {
                        this.obj_Promotion.DR.endDate = dateObj;
                    }
                    else if (event != "") {
                        this.showErrorMessage(null, String.format(this.utilGetErrorLanguage('1011'), this.getLanguage["GL"]["ED"]), 1000);
                    } else {
                        this.obj_Promotion.DR.endDate = "";
                    }
                }
            },
            closeAdd() {
                //this.selectedFile = null;
                this.bool_isAMV = !this.bool_isAMV;
                this.bool_CV = false;
            },
            checkModuleAccess2(type) {
                return this.checkModuleAccess('SMSSP', 'CRM', type);
            },
            CountItem(value) {
                if (this.int_IC != 1) {
                    return value + ((this.int_IC - 1) * this.int_RC);
                }
                else {
                    return value;
                }
            },
            ctrPage(newPage,inputValue = 1) {
                if (inputValue == 0) {
                    this.int_Page = Math.max(1, Math.min(newPage, this.int_TP));
                }
                else {
                    this.int_Page = (newPage > this.int_TP) ? 1 : (newPage < 1) ? this.int_TP : newPage;
                }
                this.int_IC = this.int_Page;
                this.getSMSList();
            },
            newSearch() {
                if (!this.bool_isAMV) {
                    this.$refs.search.focus();
                    this.int_Page = 1;
                    this.int_IC = 1;
                    this.getSMSList();
                }
            },
            getSMSList() {
                this.bool_fullLoading = true;
                var that = this;
                var path = this.getListingParamQuery(this.int_Page, this.int_RC, this.str_tableSortBy, this.bool_isSort);
                if (this.arr_search) {
                    if (path) {
                        path += "&";
                    }

                    path += (
                        "f.ST=" + (this.arr_search.ST == null ? "" : this.arr_search.ST) +
                        "&f.ATAGI=" + (this.arr_search.ATAGI == null ? "" : this.arr_search.ATAGI)
                    );
                    if (this.arr_search.DR) {
                        if (this.arr_search.DR.startDate != "") {
                            path += "&f.CTS_from=" + this.parseDateToJsonString(this.arr_search.DR.startDate);
                        }

                        if (this.arr_search.DR.endDate != "") {
                            path += "&f.CTS_to=" + this.parseDateToJsonString(this.arr_search.DR.endDate);
                        }
                    }
                }

                this.getDataApi(`/api/smssp/l?${path}`,
                    function (d, s) {
                        that.bool_fullLoading = false;
                        if (s) {
                            that.setSMSList(d.D);
                            that.resizeTableHead();
                        }
                    });
            },
            setSMSList(data) {   // this out put at SMS.js and this output after get list
                this.arr_sms = data.Items;
                this.int_TP = Math.max(data.TotalPages, 1);                
                this.int_TI = data.TotalItems;
            },
            addSMS() {
                var d = {
                    I: 0,
                    RS: 2,
                    CTS: "0001-01-01T00:00:00",
                    CBI: 0,
                    CB: null,
                    UTS: "0001-01-01T00:00:00",
                    UBI: 0,
                    UB: null,
                    PN: null,
                    AGI: 0,
                    AGIT: null,
                    ASID: "",
                    AAT: "",
                    FN: ""
                };
                d.AGIT = this.getUserInfo.AT + "-" + this.getUserInfo.AGI;
                this.bool_CV = false;
                this.isEdit = false;
                this.setSMS(d);
            },
            editSMS(id) {
                this.bool_fullLoading = true;
                this.isEdit = true;
                this.bool_CV = false;
                var that = this;
                this.getDataApi(`/api/smssp/g/${id}`,
                    function (d, s) {
                        that.bool_fullLoading = false;
                        if (s) {
                            that.setSMS(d.D);
                        }
                    });
            },
            setSMS(data) {
                this.obj_sms = Object.assign(this.obj_sms, data);
                //this.obj_sms = data;
                if (this.obj_sms.AGI != 0) {
                    this.obj_sms.AGIT = this.obj_sms.AT + '-' + this.obj_sms.AGI;
                }
                //if (this.getUserInfo.AT == 0) {
                //    this.isSuperAdmin = false;
                //}
                this.bool_isAMV = true;
            },
            ValidationErrMsg(value, langKey = "") {

                if (this.bool_CV) {

                    var validateObj = this.$v.obj_sms[value];

                    if (validateObj.required != undefined && !validateObj.required) {
                        return String.format(this.utilGetErrorLanguage('1001'), this.getLanguage["SMSSP"][langKey]);
                    }
                }

            },
            saveSMS() {
                this.bool_CV = true;
                this.$v.obj_sms.$touch();
                if (!this.$v.obj_sms.$error) {

                    if (this.obj_sms.RS) {
                        this.obj_sms.RS = 2;
                    }
                    else {
                        this.obj_sms.RS = 1;
                    }
                    if (this.obj_sms.AGIT != null && this.obj_sms.AGIT.length > 0) {
                        var agi = this.obj_sms.AGIT.split("-");
                        this.obj_sms.AGI = agi[1];
                    }

                    var that = this;
                    this.bool_fullLoading = true;
                    this.bool_fullScreen = true;

                    this.postDataApi(`/api/smssp/s`, this.obj_sms,
                        function (d, s) {
                            that.bool_fullLoading = false;
                            that.bool_fullScreen = false;
                            if (s) {
                                that.bool_isAMV = false;
                                that.getSMSList();
                            }
                        });
                } else {
                    //get the object for validating.
                    const validation = this.$v["obj_sms"];
                    if (!validation) {
                        return;
                    }

                    const input = this.findRequiredInput(validation, this.$refs);
                    if (!input || typeof input.focus !== "function") {
                        return;
                    }

                    input.focus();
                }
            },
            removeSMS(aRow) { //remove
                this.$fire({
                    title: this.getLanguage["GL"]["DLTM"],
                    width: '30em',
                    showCancelButton: true,
                    confirmButtonText: this.getLanguage["GL"]["YES"],
                    cancelButtonText: this.getLanguage["CNO"]["NO"],
                    reverseButtons: true,
                    customClass: {
                        title: 'afb-alert-title',
                        content: 'afb-alert-content',
                        actions: 'afb-alert-action'
                    }
                }).then((result) => {
                    if (result.value == true) {
                        this.bool_fullLoading = true;
                        var that = this;
                        var obj = {
                            i: aRow.I,
                            uts: aRow.UTS
                        };
                        this.postDataApi(`/api/smssp/d`, obj,
                            function (d, s) {
                                that.bool_fullLoading = false;
                                if (s) {
                                    that.getSMSList();
                                    that.showSuccessMessage(that.utilGetErrorLanguage("ERR.SS"), that.utilGetErrorLanguage("GL.AS"));
                                }
                            });
                    }
                });
            },
            setSortTable(SV) { //SV = Sort Value
                this.int_Page = 1;
                this.int_IC = 1;
                this.str_tableSortBy = SV;
                this.bool_isSort = !this.bool_isSort;//change Ascending or Descending ,and then goto the {watch:/bool_isSort}
                this.getSMSList();
            },
            setSortLogo(str_TF) {
                return `cil-${this.str_tableSortBy == str_TF ? (this.bool_isSort ? 'sort-descending' : 'sort-ascending') : 'list'}`;//here change the sort logo
            },
            clearDateRangeFilter() {
                this.arr_search.DR = {
                    startDate: "",
                    endDate: ""
                };
            },
            getDropdownList() {
                var that = this;
                this.dd_status = [{
                    id: "3",
                    label: this.getLanguage['GL']['ALL2']
                }, {
                    id: "2",
                    label: this.getLanguage['GL']['AC']
                }, {
                    id: "1",
                    label: this.getLanguage['GL']['IAC']
                }];
                this.dd_providers = [{ id: "Twilio", label: "Twilio" }];

                this.getDataApi(`/api/dd/ag/1/0`,
                    function (d, s) {
                        if (s) {

                            that.dd_agentgroup = that.deepClone(d.dropdownlist);

                            //if (that.dd_agentgroup.length > 0) {
                            //    that.dd_agentgroup.forEach(that.disableAgentGroupParent);
                            //}

                        }
                    });
            },
            //disableAgentGroupParent(item, index) {
            //    var agi = item.id.split("-");
            //    if (agi[0] != "3") {
            //        item.isDisabled = true;
            //    }

            //    if (item.children && item.children.length > 0) {
            //        item.children.forEach(this.disableAgentGroupParent);
            //    }
            //},
            updateStatus(data) {
                this.bool_fullLoading = true;
                var that = this;
                data.RS = data.RS == 2 ? 1 : 2;
                this.postDataApi(`/api/smssp/urs`, data,
                    function (d, s) {
                        that.bool_fullLoading = false;

                        if (s) {
                            that.getSMSList();
                            that.showSuccessMessage(that.utilGetErrorLanguage("ERR.SS"), that.utilGetErrorLanguage("GL.AS"));
                        }
                    });
            },
            resizeTableHead() {
                this.initTableObserver();
                // Set up scroll synchronization
                const header = this.$el.querySelector("#tHead");
                const body = this.$el.querySelector("#tBody");

                header.addEventListener("scroll", () => {
                    body.scrollLeft = header.scrollLeft;
                });

                body.addEventListener("scroll", () => {
                    header.scrollLeft = body.scrollLeft;
                });
            },
            calculateWidths() {
                $('#tHead, #tBody').scrollLeft(0);
                const tables = this.$el.querySelectorAll('#tBody .custom-table');
                const headerCells = this.$el.querySelectorAll('#tHead .custom-table thead tr:nth-child(1) th');

                if (!headerCells.length) return;

                tables.forEach((table) => {
                    const bodyCells = table.querySelectorAll('tbody tr:first-child td');
                    if (!bodyCells.length) return;

                    // Reset all widths
                    [...headerCells, ...table.querySelectorAll('tbody tr td')].forEach(cell => cell.style.width = '');

                    // Apply new widths
                    bodyCells.forEach((cell, index) => {
                        const width = `${cell.getBoundingClientRect().width}px`;
                        if (headerCells[index]) headerCells[index].style.width = width;
                        table.querySelectorAll(`tbody tr td:nth-child(${index + 1}):not(td table td)`).forEach(td => td.style.width = width);
                    });
                });
            },
            initTableObserver() {
                const bodyTable = this.$el.querySelector('#tBody');

                // Observe changes in the body table
                const observer = new MutationObserver(() => {
                    this.calculateWidths(); // Recalculate widths when rows change
                });

                observer.observe(bodyTable, { childList: true, subtree: true });
                this.calculateWidths();
            },
        },
        watch: {
            bool_isAMV() {
                if (!this.bool_isAMV && this.bool_CV) {
                    this.showSuccessMessage(this.utilGetErrorLanguage("ERR.SS"), this.utilGetErrorLanguage("GL.AS"));
                }
            },
            getLanguage() {
                this.getDropdownList();
            },

        },
        created() {
            this.$parent.showSubMenu = 'CRM';
            this.$parent.showActiveMenu = 'CRM.SMSSP';
            this.getDropdownList();
            this.getSMSList();
        }
    }

</script>
<style>
    .tab-content .tab-pane {
        padding: 15px 0px;
    }
</style>



// WEBPACK FOOTER //
// src/components/SideMenu/CRM/SMSServiceProvider.vue